import { ReactNode } from "react";

// One section-title scale, so headings stop alternating between bare <h3> and MUI Typography.
// level 2 = page/primary title, level 3 = section title.
export default function Heading({
  level = 2,
  children,
  className = "",
}: {
  level?: 2 | 3;
  children: ReactNode;
  className?: string;
}) {
  const base = "font-semibold text-gray-800 dark:text-white/90";
  if (level === 3) {
    return <h3 className={`text-lg ${base} ${className}`}>{children}</h3>;
  }
  return <h2 className={`text-theme-xl sm:text-2xl ${base} ${className}`}>{children}</h2>;
}
